import { FeatureFlagName } from '@/api/gen/featureFlagName';
import { useFeatureFlagContext } from '@/contexts/featureFlagContext';

// Off while flags load, so the notice never flashes before the flag says no.
export const useInAppBrowserNoticeDeterminer = (): boolean => {
  const { isFeatureEnabled, isLoading: isFeatureFlagLoading } = useFeatureFlagContext();

  return !isFeatureFlagLoading && isFeatureEnabled(FeatureFlagName.Y26Q4_InAppBrowserNotice);
};
